import { useAuth } from '@cibo/profile'
import { FormControl, FormLabel, Stack, TextField } from '@mui/material'
import { useField } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLabelsSearch } from '../../../queries'
import { FieldLabelAutocomplete } from '../../FieldLabelAutocomplete'

export const LabelFilter = () => {
  const { t } = useTranslation('@cibo/landmanager/LabelFilter')
  const [query, setQuery] = useState<string>()
  const { persona } = useAuth()
  const isAdmin = persona === 'admin'
  const [_, { value: labels = [] }, { setValue: setLabels }] = useField('labels')

  const { data: labelOptions } = useLabelsSearch(query)

  const displayLabels = !isAdmin
    ? labelOptions?.filter(label => label !== 'Inactive') || labelOptions
    : labelOptions

  const handleQueryChange = (event: any, value: string) => {
    setQuery(value)
  }

  const handleChangeLabels = (event: any, value: string[]) => {
    if (labels.includes('Inactive') && !value.includes('Inactive') && !isAdmin) {
      setLabels(['Inactive', ...value])
    } else {
      setLabels(value)
    }
  }

  return (
    <FormControl>
      <FormLabel>{t('labels')}</FormLabel>
      <Stack spacing={1}>
        <FieldLabelAutocomplete
          multiple
          limitTags={2}
          options={displayLabels || []}
          renderInput={params => (
            <TextField {...params} placeholder={labels.length > 0 ? t('any') : ''} />
          )}
          onChange={handleChangeLabels}
          onInputChange={handleQueryChange}
          size="small"
          value={labels}
          freeSolo
          fullWidth
        />
      </Stack>
    </FormControl>
  )
}
